import { render, staticRenderFns } from "./TabLocaleEditor.vue?vue&type=template&id=6cc04a28&scoped=true&"
import script from "./TabLocaleEditor.vue?vue&type=script&lang=js&"
export * from "./TabLocaleEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cc04a28",
  null
  
)

export default component.exports